import { render } from "./invite-message.vue?vue&type=template&id=11a402d8&lang=pug"
import script from "./invite-message.vue?vue&type=script&setup=true&lang=js"
export * from "./invite-message.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__